export const getWaterMetadataOgTitle = (
  displayName: string,
  regionName: string | null | undefined,
  countryName: string | undefined,
): string => {
  const prefix = `Check out ${displayName}`;

  if (regionName || countryName) {
    const regionAndCountry =
      regionName && countryName ? `${regionName}, ${countryName}` : `${regionName ?? countryName}`;
    return `${prefix} in ${regionAndCountry}!`;
  }
  return `${prefix}!`;
};
